import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Loader } from '@hopskipdrive/react-components';
import { uniqueId } from 'lodash';

import { PageLayout } from '../shared/components/PageLayout';
import NotFound from '../shared/pages/NotFound';

import { ProtectedRoute } from './ProtectedRoute';

function RoutesRenderer({ privateRoutes, publicRoutes }): JSX.Element {
  return (
    <Routes>
      <Route element={<PageLayout />}>
        {privateRoutes.map(({ path, component: Component, roles, nestedRoutes }) => (
          <Route
            key={uniqueId()}
            path={path}
            element={
              <ProtectedRoute key={uniqueId()} roles={roles}>
                <Component />
              </ProtectedRoute>
            }
          >
            {nestedRoutes &&
              nestedRoutes.map(
                ({
                  path: nestedRoute1Path,
                  allowedAction: nestedRoute1AllowedAction,
                  allowedSubject: nestedRoute1AllowedSubject,
                  nestedRoutes: nestedRoutes1,
                  component: NestedRoute1Component,

                  ...rest
                }) => (
                  <Route
                    key={uniqueId()}
                    path={nestedRoute1Path}
                    {...rest}
                    element={
                      <Suspense fallback={<Loader />}>
                        <ProtectedRoute
                          {...{
                            allowedAction: nestedRoute1AllowedAction,
                            allowedSubject: nestedRoute1AllowedSubject,
                          }}
                          roles={roles}
                        >
                          <NestedRoute1Component />
                        </ProtectedRoute>
                      </Suspense>
                    }
                  >
                    {nestedRoutes1 &&
                      nestedRoutes1.map(
                        ({
                          path: nestedRoute2Path,
                          allowedAction: nestedRoute2Action,
                          allowedSubject: nestedRoute2Subject,
                          component: NestedRoute2Component,
                          // eslint-disable-next-line no-shadow
                          ...rest
                        }) => (
                          <Route
                            key={uniqueId()}
                            path={nestedRoute2Path}
                            {...rest}
                            element={
                              <Suspense fallback={<Loader />}>
                                <ProtectedRoute
                                  {...{
                                    allowedAction: nestedRoute2Action,
                                    allowedSubject: nestedRoute2Subject,
                                  }}
                                  roles={roles}
                                >
                                  <NestedRoute2Component />
                                </ProtectedRoute>
                              </Suspense>
                            }
                          />
                        )
                      )}
                  </Route>
                )
              )}
          </Route>
        ))}
      </Route>
      {publicRoutes.map(({ path, component: Component }) => (
        <Route key={uniqueId()} path={path} element={<Component />} />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default RoutesRenderer;
